import { Component } from '@angular/core';

@Component({
  selector: 'app-users-layout',
  template: `
    <div class="overview__layout">
      <div class="overview__overview">
        <app-users-overview></app-users-overview>
      </div>
      <div class="overview__sidepanel">
        <app-users-sidepanel></app-users-sidepanel>
      </div>
    </div>
  `,
})
export class UserLayoutComponent {}
